import React from 'react'

import VirtualVisitInverted from '@scoir/brand-icons/dist/VirtualVisitInverted'
import PropTypes from 'prop-types'

import './MeetingLinkIcon.scss'
import hangoutsSrc from './hangouts.png'
import skypeSrc from './skype.png'
import zoomSrc from './zoom.png'

const zoomRegEx = /(zoom.us)/
const hangoutRegEx = /(google)/
const skypeRegEx = /(skype)/

const defaultType = 'defaultType'
const platforms = {
  zoom: {
    src: zoomSrc,
    alt: 'zoom logo',
    title: 'zoom logo',
  },
  google: {
    src: hangoutsSrc,
    alt: 'google hangouts logo',
    title: 'google hangouts logo',
  },
  skype: {
    src: skypeSrc,
    alt: 'skype logo',
    title: 'skype logo',
  },
}

const getPlatform = (meetingLink) => {
  if (zoomRegEx.test(meetingLink)) {
    return platforms.zoom
  }
  if (hangoutRegEx.test(meetingLink)) {
    return platforms.google
  }
  if (skypeRegEx.test(meetingLink)) {
    return platforms.skype
  }
  return defaultType
}

const MeetingLinkIcon = ({ meetingLink }) => {
  const platform = getPlatform(meetingLink)
  if (platform !== defaultType) {
    return (
      <img
        className="meeting-link-icon-comp"
        src={platform.src}
        alt={platform.alt}
        title={platform.title}
      />
    )
  }
  return <VirtualVisitInverted className="meeting-link-icon-comp-default" />
}
MeetingLinkIcon.propTypes = {
  meetingLink: PropTypes.string.isRequired,
}

export default MeetingLinkIcon
